import { FORM_FIELDS } from '../../CreateBooking/constants/FormFieldsConstants';

export const TABLE_COLUMNS = [
  { key: FORM_FIELDS.ENTRY_ID, header: 'table-header-entry-id' },
  { key: FORM_FIELDS.BRAND, header: 'table-header-brand' },
  { key: FORM_FIELDS.AE_NAME, header: 'table-header-ae-name' },
  { key: FORM_FIELDS.AM_NAME, header: 'table-header-am-name' },
  { key: FORM_FIELDS.CATEGORY, header: 'table-header-category' },
  {
    key: FORM_FIELDS.TYPE_OF_PURCHASE,
    header: 'table-header-type-of-purchase',
  },
  {
    key: FORM_FIELDS.EXACT_BILLING_VALUE,
    header: 'table-header-exact-billing-value',
  },
  {
    key: FORM_FIELDS.SF_OPPORTUNITY_ID,
    header: 'table-header-sf-opportunity-id',
  },
  { key: FORM_FIELDS.RO, header: 'table-header-ro-in' },
  { key: FORM_FIELDS.BRAND_CONFIRMATION, header: 'table-header-brand-confirmation' },
  { key: FORM_FIELDS.RODEO_AD_NAME, header: 'table-header-rodeo-advertiser-name' },
  { key: FORM_FIELDS.GTM_STATUS, header: 'table-header-gtm-status' },
  {
    key: FORM_FIELDS.SLOT_NAMES,
    header: 'table-header-slot-names',
  },
  { key: FORM_FIELDS.COMMENTS_BY_POC, header: 'table-header-comments-by-poc' },
  { key: FORM_FIELDS.CREATIVES, header: 'table-header-creatives' },
  {
    key: FORM_FIELDS.MODIFIED_AT,
    header: 'bookings-table-header-modified-at',
  },
  {
    key: FORM_FIELDS.MODIFIED_BY,
    header: 'bookings-table-header-modified-by',
  },
];
